import { EmptyInstance } from "core/features/components/mixins/empty-instance";
import { EventEmitterMixin } from "front-end/mixins/event-emitter.mixin";

export class PageFooterComponent extends EventEmitterMixin(EmptyInstance) {
    public static SELECTOR: string = ".js-ina-footer";

    private _currentContext: JQuery = $();

    public updateStyles(): void {
        const navigation = $(".js-ina-navigation");
        if (navigation.hasClass("show"))
        {
            this._currentContext.css("z-index", "-1");
        }
        else {
            this._currentContext.css("z-index", "0");
        }
    }

    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;
    }
}
